import { useQuery } from '@tanstack/react-query';
import CompanyService from '@/services/company-service';

const LS_PREFIX = 'cz_co_';

function lsRead(t: any, c: any) {
  try {
    const raw = localStorage.getItem(`${LS_PREFIX}${t}_${c}`);
    return raw ? JSON.parse(raw) : undefined;
  } catch { return undefined; }
}

function lsWrite(t: any, c: any, data: any) {
  try {
    localStorage.setItem(`${LS_PREFIX}${t}_${c}`, JSON.stringify(data));
  } catch {}
}

export function useCustomerZoneCompany(t: any, c: any, api: any) {
  return useQuery({
    queryKey: ['czCompany', t, c],
    queryFn: async () => {
      const data = await CompanyService.getCustomerZoneCompany(t, c, api);
      lsWrite(t, c, data);
      return data;
    },
    enabled: !!api,
    initialData: () => lsRead(t, c),
    staleTime: 30 * 60 * 1000,
  });
}
